import { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from "../../common/with-router";
import {
  Card,
  Button,
  Row,
  Col,
  Table,
  Badge,
} from "react-bootstrap";
import {
  FaPlus,
  FaRegEdit,
  FaFilePdf,
  FaTrash,
  FaEye,
} from "react-icons/fa";
import api from "../../services/api";
import { hasPerm } from "../../common/utils";
import Paginacao from "../../common/pagination";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal); 

class TermosPlataforma extends Component {
  constructor(props) {
    super(props);
    this.onClickPagina = this.onClickPagina.bind(this);
    this.consultaRegistro = this.consultaRegistro.bind(this);
    this.handleDelete = this.handleDelete.bind(this);

    this.state = {
      listRegistros: [],
      error: "",
      page_numb: 1,
      loading: true,
    };
  }

  componentDidMount() {
    this.consultaRegistro(this.state.page_numb);
  }

  consultaRegistro(page_numb = 1) {
    api
      .get(`/termos-plataforma/admin/?page=${page_numb}`)
      .then((response) => {
        this.setState({
          loading: false,
          error: "",
          listRegistros: response.data,
        });
      })
      .catch((error) => {
        let erro_msg = "Erro ao consultar termos, tente novamente.";
        if (error.response && error.response.status === 403) {
          erro_msg = "Você não tem permissão para acessar essa área";
        }
        this.setState({
          loading: false,
          error: erro_msg,
        });
      });
  }

  handleDelete = (id) => {
    MySwal.fire({
      title: "Tem certeza?",
      text: "Você realmente deseja excluir esta VERSÃO do termo? Esta ação não pode ser desfeita depois. [AVISO]: TODOS OS LOGS DE ACEITES RELACIONADOS SERÃO EXCLUIDOS PARA INTEGRIDADE TERMOxLOG",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sim, excluir!",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.setState({ loading: true });
        try {
          await api.delete(`/termos-plataforma/admin/${id}/`);
          MySwal.fire(
            "Excluído!",
            "A versão do termo foi excluída.",
            "success"
          );
          this.consultaRegistro(this.state.page_numb);
        } catch (err) {
          MySwal.fire("Erro!", "Não foi possível excluir o termo.", "error");
          console.error(err);
          this.setState({ loading: false });
        }
      }
    });
  };

  renderRows = () => {
    if (
      "results" in this.state.listRegistros &&
      this.state.listRegistros.results.length > 0
    ) {
      return this.state.listRegistros.results.map((item) => (
        <tr key={item.id}>
          <td>{item.id}</td>
          <td>{item.titulo}</td>
          <td>{item.slug}</td>
          <td>{item.versao}</td>
          <td>
            {item.is_active ? (
              <Badge bg="success">Ativo</Badge>
            ) : (
              <Badge bg="secondary">Inativo</Badge>
            )}
          </td>
          <td>
            {item.tipos_usuarios_display
              ? item.tipos_usuarios_display.join(", ")
              : ""}
          </td>
          <td>
            {item.arquivo_pdf_url ? (
              <Button
                variant="link"
                size="sm"
                href={item.arquivo_pdf_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFilePdf /> Ver PDF
              </Button>
            ) : (
              "-"
            )}
          </td>
          <td>
            <Button
              variant="light"
              href={`/termos-plataforma/edit/${item.id}`}
              size="sm"
              className="me-1"
            >
              <FaRegEdit /> Editar
            </Button>
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => this.handleDelete(item.id)}
            >
              <FaTrash />
            </Button>
          </td>
        </tr>
      ));
    }

    return (
      <tr>
        <td colSpan={8}>Nenhum termo cadastrado</td>
      </tr>
    );
  };

  onClickPagina(num_page) {
    this.setState({
      loading: true,
      page_numb: num_page,
    });

    this.consultaRegistro(num_page);
  }

  render() {
    if (!hasPerm("view_termoplataforma")) {
      return <Navigate to="/sem-permissao" />;
    }

    return (
      <div>
        <Row className="align-items-center">
          <Col sm={6} lg={6}>
            <h4 className="page-title">Termos da Plataforma</h4>
          </Col>
          <Col sm={6} lg={6} className="text-end">
            <Button
              variant="outline-info"
              href="/termos-plataforma/aceites"
              className="mb-3 me-2"
              size="sm"
            >
              <FaEye /> Ver Aceites
            </Button>
            <Button
              variant="secondary"
              href="/termos-plataforma/add"
              className="mb-3"
              size="sm"
            >
              <FaPlus /> Adicionar Termo
            </Button>
          </Col>
        </Row>
        <Card className="cardDestaque">
          <Card.Body>
            <Table responsive className="custom-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Título</th>
                  <th>Slug</th>
                  <th>Versão</th>
                  <th>Status</th>
                  <th>Tipos de Usuário</th>
                  <th>PDF</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {this.state.loading ? (
                  <tr>
                    <td colSpan={8}>Carregando...</td>
                  </tr>
                ) : this.state.error ? (
                  <tr>
                    <td colSpan={8}>{this.state.error}</td>
                  </tr>
                ) : (
                  this.renderRows()
                )}
              </tbody>
            </Table>
            {"results" in this.state.listRegistros &&
              this.state.listRegistros.results.length > 0 && (
                <Paginacao
                  dados={this.state.listRegistros}
                  loading={this.state.loading}
                  page_numb={this.state.page_numb}
                  _onClickPagina={this.onClickPagina}
                />
              )}
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default withRouter(TermosPlataforma);
